export default "__VITE_ASSET__Ct2d11SO__"